export default __webpack_public_path__ + "static/media/trianguloVermelhoInvertido.db87bb57.png";